var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1VenetianBlindLevel34(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 26H17v-6h42v6zm0 4H17v6h42v-6zm0 10H17v6h42v-6zm0 9h-3v4H17v3h42v-7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Venetian_blind_level_3-4.6fd155bd.svg";
export { SvgC1VenetianBlindLevel34 as ReactComponent };